export default "__VITE_ASSET__b8b521bb__"